import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface BulkActionBarProps {
  count: number;
  enabledCount: number;
  isAnyPending: boolean;
  onRun: () => void;
  onDisable: () => void;
  onDelete: () => void;
  onClear: () => void;
}

export const BulkActionBar: React.FC<BulkActionBarProps> = ({
  count,
  enabledCount,
  isAnyPending,
  onRun,
  onDisable,
  onDelete,
  onClear,
}) => {
  return (
    <div
      role="region"
      aria-label="Bulk actions"
      className="sticky top-0 z-10 flex items-center gap-2 border-b bg-background px-3 py-2"
    >
      <span className="text-sm font-medium">{count} selected</span>
      <div className="flex-1" />
      <Button size="sm" onClick={onRun} disabled={isAnyPending}>
        Run
      </Button>
      {enabledCount > 0 ? (
        <Button
          size="sm"
          variant="outline"
          onClick={onDisable}
          disabled={isAnyPending}
        >
          Disable ({enabledCount})
        </Button>
      ) : null}
      <Button
        size="sm"
        variant="destructive"
        onClick={onDelete}
        disabled={isAnyPending}
      >
        Delete
      </Button>
      <Button
        size="icon"
        variant="ghost"
        onClick={onClear}
        aria-label="Clear selection"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
